import React from "react";
import PropTypes from "prop-types";

const TextBox = ({
  type,
  placeholder,
  onChange,
  value,
  error,
  children,
  label,
  id,
  ...props
}) => {
  return (
    <>
      <input
        id={id}
        type={type}
        disabled={props.disabled}
        placeholder={placeholder}
        onChange={onChange}
        value={value || ""}
        className="form-control form-control-sm shadow-none"
        style={{
          fontWeight: 400,
        }}
      />
      {error && <p>{error}</p>}
    </>
  );
};

TextBox.propTypes = {
  placeholder: PropTypes.string.isRequired,
  type: PropTypes.oneOf(["text", "number", "password"]),
  value: PropTypes.any,
  onChange: PropTypes.func.isRequired,
};

export default TextBox;
